<div class="row">
	<div class="col mb-3">
		<div class="form-floating">
			<select class="form-select" id="parentId" [formControl]="parentCtrl" required 
				(blur)="parentCtrl.markAsTouched()" [class.is-invalid]="parentCtrl.touched && parentCtrl.invalid">
				<option *ngFor="let parent of parentList" [ngValue]="parent">{{parent.value}}</option>
			</select>
			<label for="parentId">{{parentPlaceholder}}<span class="mandatory">*</span></label>
			<div *ngIf="parentCtrl.touched && parentCtrl.invalid" class="alert alert-danger">
				{{parentPlaceholder}} is required
			</div>
		</div>
	</div>
	<div class="col mb-3">
		<div *ngIf="childList" class="form-floating">
			<select class="form-select" id="childId" [formControl]="childCtrl" required
				(blur)="childCtrl.markAsTouched()" [class.is-invalid]="childCtrl.touched && childCtrl.invalid">
				<option *ngFor="let child of childList" [ngValue]="child">{{child.value}}</option>
			</select>
			<label for="childId">{{childPlaceholder}}<span class="mandatory">*</span></label>
			<div *ngIf="childCtrl.touched && childCtrl.invalid" class="alert alert-danger">
				{{childPlaceholder}} is required
			</div>
		</div>
	</div>
	<div class="col mb-3">
		<div *ngIf="grandChildList" class="form-floating">
			<select class="form-select" id="grandChildId" [formControl]="grandChildCtrl" required
				(blur)="grandChildCtrl.markAsTouched()" [class.is-invalid]="grandChildCtrl.touched && grandChildCtrl.invalid">
				<option *ngFor="let grandChild of grandChildList" [ngValue]="grandChild">{{grandChild.value}}</option>
			</select>
			<label for="grandChildId">{{grandChildPlaceholder}}<span class="mandatory">*</span></label>
			<div *ngIf="grandChildCtrl.touched && grandChildCtrl.invalid" class="alert alert-danger">
				{{grandChildPlaceholder}} is required
			</div>
		</div>
	</div>
</div>

<!-- 

<div>
    <mat-form-field class="full-width">
        <mat-select matInput 
            [placeholder]="parentPlaceholder" 
            [formControl]="parentCtrl">
            <mat-option *ngFor="let parent of parentList" [value]="parent.value" (click)='setParent(parent);$event.stopPropagation()'>
                <span>{{parent.value}}</span>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="parentCtrl
                        && !parentCtrl.hasError('minlength')
                        && !parentCtrl.hasError('maxlength')
                        && !parentCtrl.hasError('required')
                        && !parentCtrl.hasError('pattern')">
            <div>Oops, there's a problem with your input</div>
            <div *ngFor="let err of getErrorList(parentCtrl.errors)">
                    {{err}}
            </div>
        </mat-error>
    </mat-form-field>
</div>
<div *ngIf="childList">
    <mat-form-field class="full-width">
        <mat-select matInput 
            [placeholder]="childPlaceholder"
            [formControl]="childCtrl">
            <mat-option *ngFor="let child of childList" [value]="child.value" (click)='setChild(child);$event.stopPropagation()'>
                <span>{{child.value}}</span>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="childCtrl
                        && !childCtrl.hasError('minlength')
                        && !childCtrl.hasError('maxlength')
                        && !childCtrl.hasError('required')
                        && !childCtrl.hasError('pattern')">
            <div>Oops, there's a problem with your input</div>
            <div *ngFor="let err of getErrorList(childCtrl.errors)">
                    {{err}}
            </div>
        </mat-error>
    </mat-form-field>
</div>
<div *ngIf="grandChildList">
    <mat-form-field class="full-width">
        <mat-select matInput 
            [placeholder]="grandChildPlaceholder" 
            [formControl]="grandChildCtrl" >
            <mat-option *ngFor="let grandChild of grandChildList" [value]="grandChild.value" (click)='setGrandChild(grandChild);$event.stopPropagation()'>
                <span>{{grandChild.value}}</span>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="grandChildCtrl
                        && !grandChildCtrl.hasError('minlength')
                        && !grandChildCtrl.hasError('maxlength')
                        && !grandChildCtrl.hasError('required')
                        && !grandChildCtrl.hasError('pattern')">
            <div>Oops, there's a problem with your input</div>
            <div *ngFor="let err of getErrorList(grandChildCtrl.errors)">
                    {{err}}
            </div>
        </mat-error>
    </mat-form-field>
</div>
<div *ngIf="greatGrandChildList">
    <mat-form-field class="full-width">
        <mat-select matInput 
            [placeholder]="greatGrandChildPlaceholder" 
            [formControl]="formCtrl" >
            <mat-option *ngFor="let greatGrandChild of greatGrandChildList" [value]="greatGrandChild.value" (click)='setGreatGrandChild(greatGrandChild);$event.stopPropagation()'>
                <span>{{greatGrandChild.value}}</span>
            </mat-option>
        </mat-select>
        <mat-error *ngIf="formCtrl
                        && !formCtrl.hasError('minlength')
                        && !formCtrl.hasError('maxlength')
                        && !formCtrl.hasError('required')
                        && !formCtrl.hasError('pattern')">
            <div>Oops, there's a problem with your input</div>
            <div *ngFor="let err of getErrorList(formCtrl.errors)">
                    {{err}}
            </div>
        </mat-error>
    </mat-form-field>
</div> -->